import { useQuery } from "@tanstack/react-query";
import { useAPI } from "./useAPI";
import { useAuth } from "../contexts/AuthContext";

const mapProgramToEnrollment = (program) => {
  const allScenarios = program.chapters.flatMap((c) => c.scenarios);
  const sessions = allScenarios.filter((s) => !s.has_scoring_engine);
  const simulations = allScenarios.filter((s) => s.has_scoring_engine);

  const totalCount = allScenarios.length;
  const completedCount = allScenarios.filter((s) => s.completed).length;
  const overallProgress =
    totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
  const isCompleted = totalCount > 0 && completedCount === totalCount;

  const nextScenario = allScenarios.find((s) => !s.completed);

  return {
    programId: program.id,
    program: {
      id: program.id,
      title: program.name,
      poster: program.image,
      category: program.category ?? undefined,
      guru: program.guru_info
        ? { name: program.guru_info.full_name, avatar: program.guru_info.photo ?? "" }
        : undefined,
    },
    type: program.is_trial ? "trial" : "paid",
    enrolledOn: new Date().toISOString(),
    daysLeftInTrial: program.subscription_expires_at
      ? Math.max(0, Math.ceil((new Date(program.subscription_expires_at) - Date.now()) / (1000 * 60 * 60 * 24)))
      : undefined,
    overallProgress,
    sessionsCompleted: sessions.filter((s) => s.completed).length,
    sessionsTotal: sessions.length,
    simulationsCompleted: simulations.filter((s) => s.completed).length,
    simulationsTotal: simulations.length,
    completed: isCompleted,
    lastActivity: new Date().toISOString(),
    nextSession: nextScenario
      ? {
          title: nextScenario.name,
          duration: "",
          type: nextScenario.has_scoring_engine ? "sim" : "skill",
        }
      : undefined,
  };
};

export const useSubscribedPrograms = () => {
  const { callAPI } = useAPI();
  const { authToken } = useAuth();
  const is2FA = window.location.pathname.toLowerCase().includes("2fa");

  return useQuery({
    queryKey: ["trainingprograms", "subscribed"],
    queryFn: () =>
      callAPI("trainingprograms?show_subscribed=true", { token: authToken }),
    enabled: !!authToken && !is2FA,
    staleTime: 5 * 60 * 1000,
    select: (data) => (Array.isArray(data) ? data.map(mapProgramToEnrollment) : []),
  });
};
